import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-customer",
  "use": "icon-customer-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-customer\"><path d=\"M512 288m-224 0a224 224 0 1 0 448 0 224 224 0 1 0-448 0Z\" fill=\"\" p-id=\"5824\" /><path d=\"M583.1 517.6L512 588.7l-71.1-71.1C227.3 551.7 64 736.8 64 960h896c0-223.2-163.3-408.3-376.9-442.4zM512 896l-76.7-76.7L512 589l76.7 230.4L512 896z\" fill=\"\" p-id=\"5825\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol